<template>
  <div class="filter-freesearch-container">
    <div class="filter-freesearch-toggle-btn-container" v-if="simpleSearchCompactMode">
      <a href="#"
        class="i-button btn i-simple-btn i-btn-sm i-free-search-toggle"
        @click.prevent="() => setSimpleSearchCompactMode(false)"
        ><i style="margin-right: 4px; margin-top: -4px; margin-left: 0px"
          class="fa5 fas fa-search"
          aria-hidden="true"
        ></i>
        <span class="i-btn-label">{{ LANG.search }}</span>
      </a>
    </div>

    <div class="filter-freesearch-input-container" v-else>
      <div class="i-filter-free-search filter-free-search">
        <input
          type="text"
          class="form-control i-filter-free-search-input"
          v-bind="$attrs"
          :placeholder="$attrs.placeholder || 'Search'"
          :value="simpleSearchTerm"
          @input="(event) => setSimpleSearchTerm(event.target.value)"
          v-on:keydown.enter.prevent="() => runSimpleSearchQuery(simpleSearchTerm)"
        />
        <button
          class="i-simple-btn filter-free-search-btn i-filter-free-search-btn i-free-search-trigger"
          type="button"
          @click="() => runSimpleSearchQuery(simpleSearchTerm)">
          <i aria-hidden="true"
            title="Search"
            class="fa5 fas fa-search filter-free-search-icon i-filter-free-search-icon"
            name="search"
          ></i>
          <span class="sr-only">{{ LANG.search }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import { mapBrowserState, mapBrowserMutations } from '@/store';

export default {
  props: [],
  inheritAttrs: false,
  computed: {
    ...mapBrowserState([
      'simpleSearchCompactMode',
      'simpleSearchTerm',
    ]),
    ...mapState(['LANG']),
  },
  methods: {
    ...mapBrowserMutations([
      'setSimpleSearchTerm',
      'setSimpleSearchCompactMode',
      'runSimpleSearchQuery',
    ]),
  },
};
</script>

<style scoped>
  .filter-freesearch-container {
    display: inline-block;
  }
  @media screen and (max-width: 1055px) {
    .filter-freesearch-container {
        display: none;
    }
  }
</style>
